export function resourceDownloads() {
  document.addEventListener("DOMContentLoaded", function () {
    var pdfButtons = document.querySelectorAll(".pdf-download-button");
    var centralizedForm = document.getElementById("centralized-pdf-form");

    if (centralizedForm) {
      pdfButtons.forEach(function (button) {
        button.addEventListener("click", function (e) {
          e.preventDefault();

          var pdfURL = e.target.getAttribute("data-pdf-url");
          var hiddenInput = centralizedForm.querySelector(
            'input[name="pdf-download"]'
          );
          if (hiddenInput) {
            hiddenInput.value = pdfURL;
          }

          centralizedForm.classList.add("show-form");
        });
      });

      centralizedForm.addEventListener("submit", function (event) {
        event.preventDefault();

        var hiddenInput = centralizedForm.querySelector(
          'input[name="pdf-download"]'
        );
        if (hiddenInput && hiddenInput.value) {
          window.location.href = hiddenInput.value;
        }
      });
    }
  });
}
